// ── API Endpoints (SANS préfixe /api — le client axios l'ajoute) ──
// Centralise les endpoints partagés de lib/ (hooks collections, planning,
// notifications, permissions, stores utilisateur).

export const API_ENDPOINTS = {
  // ── Références (hooks collections) ──
  CATEGORIE_DOCUMENTS: "/categorie_documents",
  CIVILITES: "/civilites",
  COMPETENCES: {
    LIST: "/competences",
    SIMPLE: "/competences/simple",
  },
  DEPARTEMENTS: "/departements",
  ETAT_DEMANDES: "/etat_demandes",
  FILIALES: "/filiales",
  HOLIDAYS: "/holidays",
  PERSONNES: "/personnes",
  TYPE_CONTRATS: "/type_contrats",
  TYPE_DEMANDES: "/type_demandes",
  TYPE_DOCUMENTS: "/type_documents",
  TYPE_FOURNISSEURS: "/type_fournisseurs",
  TYPE_PLANNING_ITEMS: "/type_planning_items",
  TYPE_REMUNERATIONS: "/type_remunerations",
  TYPE_STATUTS: "/type_statuts",
  TYPE_TEMPS_DE_TRAVAIL: "/type_temps_de_travails",

  // ── Planning ──
  PLANNING_ITEMS: {
    CREATE: "/planning_items",
    QUERY: (params: URLSearchParams) => `/planning_items?${params.toString()}` as const,
    DETAIL: (id: number | string) => `/planning_items/${id}` as const,
    UPDATE: (id: number | string) => `/planning_items/${id}` as const,
    DELETE: (id: number | string) => `/planning_items/${id}` as const,
  },
  PLANNING_TEMPLATES: "/planning_templates",

  // ── Notifications ──
  NOTIFICATIONS: {
    LIST: "/notifications",
    READ: (id: number | string) => `/notifications/${id}` as const,
    DELETE: (id: number | string) => `/notifications/${id}` as const,
    MARK_ALL_READ: "/notifications/mark-all-read",
  },

  // ── Documents ──
  DOCUMENTS: {
    DOWNLOAD: (docId: number | string) => `/documents/${docId}/download` as const,
  },

  // ── Permissions utilisateur ──
  USER_PERMISSIONS: (userId: number | string) => `/users/${userId}/permissions` as const,

  // ── Auth ──
  // ⚠️ `LOGOUT` is the one endpoint here that must NOT go through the `api`
  // instance: its response interceptor turns a 401 into a refresh-token attempt,
  // and `logout()` runs after the store's token is already wiped. It is called
  // with a raw `axios` (no baseURL) — see `logout()` in lib/auth/authStore.ts.
  AUTH: {
    LOGOUT: "/logout",
  },

  // ── Utilisateurs ──
  USERS: {
    DETAIL: (userId: number | string) => `/users/${userId}` as const,
  },

  // ── Réglages utilisateur ──
  USER_SETTINGS: {
    DETAIL: (userId: number | string) => `/user_settings/${userId}` as const,
    UPDATE: (userId: number | string) => `/user_settings/${userId}` as const,
  },

  // ── Mercure ──
  MERCURE_TOKEN: "/mercure/token",
} as const;

// ── Contexte filiale (sélecteur multi-filiale) ──
// Headers injectés par l'intercepteur axios (lib/api/client.ts) et lus par
// le backend (FilialeAccessService / FilialeAccessExtension).
export const CONTEXT_HEADERS = {
  FILIALES: "X-Context-Filiales",
  DEPT: "X-Context-Dept",
} as const;
